<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
        <div class="row m-0">
          <ul class="nav menu">
            <li><a class="tab-a" href="" [routerLink]="['/supplier-group']" >Group</a></li>
            <li class="active"><a href="" [routerLink]="['/company']">Company</a></li>
            <li ><a class="tab-a" href="#" >Site</a></li>
          </ul>
        </div>

        <div class="row m-0 pb-2 align-center">
          <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
            <h4 class="title">SEARCH</h4>
          </div>

          <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
            <button type="button" class="btn btn-custom btn-blue float-right">
              <i class="fa fa-plus-square-o pr-2"></i> Create Supplier
            </button>
          </div>
        </div>

        <div class="row m-0 align-center">
          <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
            <label class="label-control">Identifier Type</label>
            <mat-select   class="form-control form-control-sm" [(ngModel)]="identifierTypeModel" (change)="selectChangeHandler($event)"  panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value="business-entities" selected="selected">Alliance Supplier ID</mat-option>
              <mat-option *ngFor="let identifierType of identifierTypes" value="company-identifiers$${{identifierType.row_id}}$${{identifierType.name}}">{{identifierType.name}}</mat-option>
              <mat-option *ngFor="let businessEntityIdentifierType of businessEntityIdentifierTypes" value="business-entity-identifiers$${{businessEntityIdentifierType.row_id}}$${{businessEntityIdentifierType.name}}">{{businessEntityIdentifierType.name}}</mat-option>
            </mat-select>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
            <label class="label-control">Identifier Value
            </label>
            <p class="border-right pr-4 m-0">
                <ng-select class="form-control-sm custom" [searchFn]="customSearchFn"  [typeahead] [items]="suppliervalDropDown"  bindLabel="allianceIdentifierSelect"
                bindValue="row_id" [(ngModel)]="identifierValueModel"  (change)="resetSelectedFields('supplierNameModel')">
                </ng-select></p>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
            <label class="label-control">Supplier name
            </label>
            <p class="pr-4 m-0">
              <ng-select class="form-control-sm custom"  [searchFn]="customSearchFn1"  [typeahead] [items]="supplierNameDropDown"  bindLabel="allianceIdentifierLegalname"
              bindValue="row_id" [(ngModel)]="supplierNameModel"   (change)="resetSelectedFields('identifierValueModel')">
              </ng-select></p>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 text-right">
            <label class="label-control hidden"> &nbsp; </label>
            <button type="button" class="btn btn-custom btn-link" (click)="resetSelectedFields('')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields(''))"> Clear All </button>
            <button type="button" class="btn btn-custom btn-blue" (click)="getChangeHandler()"> Search </button>
          </div>
        </div>
      </section>

      <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
        <div class="row m-0 pt-3 align-center">
          <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
            <h4 class="title">RESULT</h4>
          </div>

          <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
            <button type="button" class="btn btn-custom btn-blue float-right">
              <i class="fa fa-upload pr-2" aria-hidden="true"></i> Export
            </button>
          </div>
        </div>

        <div class="row m-0">
          <div class="table-responsive mt-3">
            <table class="table table-sm m-0">
              <thead>
                <tr>
                  <th>Supplier Legal Name</th>
                  <th>Alliance Supplier ID</th>
                  <th>BvD ID</th>
                  <th>Street</th>
                  <th>ZIP Code</th>
                  <th>City</th>
                  <th>Country</th>
                </tr>
              </thead>

              <tbody *ngIf="listFlag == true && supplierDataLists && supplierDataLists.length>=0" #customLoadingTemplate>
                <tr *ngFor="let supplierDataList of supplierDataLists">
                  <td class="font-weight-bold label-darkblue">{{supplierDataList.allianceIdentifierLegalname}}</td>
                  <td>{{supplierDataList.allianceIdentifierSelect}}</td>
                  <td>{{supplierDataList.bvdid}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
              <tbody *ngIf="listFlag == false" #customLoadingTemplate>
                <tr>
                  <td colspan="7" class="font-weight-bold label-darkblue text-center"> No records found.</td>
                </tr>

              </tbody>
              <!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>        -->
               <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
            <!-- Spinner -->
            </table>

           </div>
        </div>
      </section>

    </div>